module.exports = __webpack_public_path__ + "static/img/guide-kegel.abd89c88.png";